import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای ردیابی شمارهٔ سریال

این بخش به شما امکان می‌دهد تا با اسکن یا تایپ یک شماره سریال، کل زنجیره ساخت و قطعات مصرفی آن (ردیابی و رهگیری) را مشاهده کنید. 

## ۱. جستجوی سریال
در کادر جستجو، شماره سریال محصول نهایی یا قطعه را اسکن یا تایپ کنید. در صورت وجود، اطلاعات ساخت آن شامل سفارش کار و وضعیت فریز بودن تاریخچه نمایش داده می‌شود.

## ۲. زنجیره نسب (Genealogy Tree)
نمودار درختی از تمامی قطعات و مواد اولیه‌ای که در ساخت این سریال استفاده شده‌اند، همراه با شماره سریال و شماره پالت‌های آنها نمایش داده می‌شود.

## ۳. پالت‌های مستقیم
در بخش پایین، لیست پالت‌هایی که به طور مستقیم در ایستگاه‌های کاری برای این محصول مصرف شده‌اند (همراه با مقادیر) قابل مشاهده است.

<Alert type="info">این بخش تمامی الزامات ردیابی (Traceability) طبق استانداردها را برای یک شماره سریال خاص برآورده می‌کند.</Alert>

export default Layout;
